<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="inspFilteringGroupName"
    item-value="inspFilteringGroupCd"
    :label="labelComputed"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'InspFilteringInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0143')
      },
    },
    disabledComputed: {
      get() {
        return this.disabled
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
      }
      this.items = await API.get('/master/inspFilteringGroups', params)
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
